import * as React from 'react';
import {Component} from '../lib/component';
import {classes, style} from 'typestyle';
import {colorWhite} from "../theme/color";
import {
    center,
    startJustified,
    vertical
} from "csstips";
import MHeaderImage from '../static/M1-Hero-Image.jpg';
import MHeaderImageGradient from '../static/M1-Hero-Gradient.png';
import DHeaderImage from '../static/D1-Hero-Image.jpg';
import DHeaderImageGradient from '../static/D1-Hero-Gradient.png';
import TubeBuddyLogo from '../static/TubeBuddy.svg'
import DownArrow from '../static/expand_more.png';
import LickdLogo from '../static/lickd_logo.svg';
import {fontBody, fontHeading} from "../theme/font";
import {ButtonPill} from "../components/button-pill";
import {mediaDesktop, mediaMobileOnly, mediaTablet, mediaTabletOnly} from "../theme/media";
import {Head} from "./head";
import MabelImage from "../static/Hottest-Tracks-Artist-Image-03.jpg";
import AnneMarieImage from "../static/Hottest-Tracks-Artist-Image-02.jpg";
import XxxTentacionImage from "../static/Hottest-Tracks-Artist-Image-01.jpg";


export interface TubebuddyPageProps {};

export class TubebuddyPage extends Component<TubebuddyPageProps> {

    componentDidMount(): void {
        let searchParams = new URLSearchParams(window.location.search);

        if (searchParams.has('fsUserId')) {
            document.cookie = "mcn_user_id=" + searchParams.get('fsUserId');
        }

        if (searchParams.has('token')) {
            document.cookie = "mcn_token=" + searchParams.get('token');
        }

        document.cookie = "mcn_name=tubebuddy";
    }

    render(): JSX.Element | false | null {
        return (
            <div className={classes(TubebuddyPage.styles.background)}>
                <Head />
                <div className={classes(TubebuddyPage.styles.container)}>
                    <div className={classes(TubebuddyPage.styles.hero)}>
                        <img src={MHeaderImage} srcSet={`${MHeaderImage} 640w, ${DHeaderImage} 2560w`} />
                        <img src={MHeaderImageGradient} srcSet={`${MHeaderImageGradient} 640w, ${DHeaderImageGradient} 2560w`} />
                        <div className={classes(TubebuddyPage.styles.logos)}>
                            <img src={LickdLogo} />
                            <img src={TubeBuddyLogo} />
                        </div>
                        <div className={classes(TubebuddyPage.styles.heroInner)}>
                            <div className={classes(TubebuddyPage.styles.heroInnerText)}>
                                Use the music you love and get 15% off.
                            </div>
                            <ButtonPill href={"/?show-sign-up&?utm_medium=referral&utm_source=tubebuddy&utm_campaign=tubebuddy-lander-download"} primary={false}>Download first track</ButtonPill>
                        </div>
                        <div className={classes(TubebuddyPage.styles.readMore)}>
                            <div>Read more</div>
                            <img src={DownArrow} width="12" height="8"/>
                        </div>
                    </div>
                    <div className={TubebuddyPage.styles.content}>
                        <div className={classes(TubebuddyPage.styles.contentMain)}>
                            <div>
                                <h4>What is Lickd?</h4>
                                <p>Lickd is the first (and only) online platform that allows you to quickly and easily license popular music from signed artists for your social videos. You’ll keep all of your advertising revenue and never worry about a copyright claim again.</p>
                                <p>Each track in our 50,000+ strong library (including instrumentals) is protected by our VOUCH technology, which means you can finally use the music you love without the fear of copyright infringement. Where we can't offer automatic clearances, our team will be on hand to remove any claims asap with no impact on your channel. Your ad revenue is now yours to keep.</p>
                            </div>
                            <div>
                                <h4>VIP Lickd benefits</h4>
                                <p>As a part of the TubeBuddy network, when you sign up you’ll now have access to exclusive benefits and deals from Lickd:</p>
                                <ul>
                                    <li>You get 15% off every order as long as you’re part of TubeBuddy</li>
                                    <li>Get notified first as new tracks are added to Lickd</li>
                                    <li>Access to exclusive content and competitions</li>
                                </ul>
                            </div>
                        </div>
                        <div className={classes(TubebuddyPage.styles.downloadCta)}>
                            <ButtonPill href={"/?show-sign-up&?utm_medium=referral&utm_source=tubebuddy&utm_campaign=tubebuddy-lander-download"} primary={false}>Download first track</ButtonPill>
                        </div>
                        <h4>Lickd's hottest tracks</h4>
                        <div className={classes(TubebuddyPage.styles.hottestTracks)}>
                            <div className={classes(TubebuddyPage.styles.artist)}>
                                <a href={"/?show-sign-up&?utm_medium=referral&utm_source=tubebuddy&utm_campaign=tubebuddy-lander-download"}>
                                    <div>
                                        <img src={LickdLogo} />
                                        <div className={classes(TubebuddyPage.styles.artistImage)}>
                                            <div className={classes(TubebuddyPage.styles.artistName)}>
                                                <div>XXXtentacion</div>
                                                Listen and license
                                            </div>
                                            <img src={XxxTentacionImage}/>
                                            <img className={classes('gradient')} src={MHeaderImageGradient} width="255" height="288"/>
                                        </div>
                                    </div>
                                </a>
                                XXXtentacion’s track Sad! sent the artist’s second studio album to the number one spot on the Billboard 200. The raw energy in his music’s guaranteed to give your next video the edge.
                            </div>
                            <div className={classes(TubebuddyPage.styles.artist)}>
                                <a href={"/?show-sign-up&?utm_medium=referral&utm_source=tubebuddy&utm_campaign=tubebuddy-lander-download"}>
                                    <div>
                                        <img src={LickdLogo} />
                                        <div className={classes(TubebuddyPage.styles.artistImage)}>
                                            <div className={classes(TubebuddyPage.styles.artistName)}>
                                                <div>Anne-Marie</div>
                                                Listen and license
                                            </div>
                                            <img src={AnneMarieImage}/>
                                            <img className={classes('gradient')} src={MHeaderImageGradient} width="255" height="288"/>
                                        </div>
                                    </div>
                                </a>
                                Chart-topping artist Anne-Marie has gone platinum with tracks like “Alarm” and “Ciao Adios”, now available to download from Lickd. If you’re in need of some high energy pop, these ones are for you.
                            </div>
                            <div className={classes(TubebuddyPage.styles.artist)}>
                                <a href={"/?show-sign-up&?utm_medium=referral&utm_source=tubebuddy&utm_campaign=tubebuddy-lander-download"}>
                                    <div>
                                        <img src={LickdLogo} />
                                        <div className={classes(TubebuddyPage.styles.artistImage)}>
                                            <div className={classes(TubebuddyPage.styles.artistName)}>
                                                <div>Mabel</div>
                                                Listen and license
                                            </div>
                                            <img src={MabelImage}/>
                                            <img className={classes('gradient')} src={MHeaderImageGradient} width="255" height="288"/>
                                        </div>
                                    </div>
                                </a>
                                With 2.5 billion streams worldwide, global chart queen, Mabel, is the latest artist to drop from our collab with Universal. Mabel’s pumping-pop classic “Don’t Call Me Up” is a platinum single you don’t want to miss out on.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    static styles = {
        background: style({
            ...vertical,
            ...center,
            ...startJustified,
            minHeight: '100%',
            padding: 0,
            backgroundColor: "rgb(249, 249, 249)",
        }),
        container: style({
            overflow: "hidden",
            boxShadow: "rgba(0, 0, 0, 0.1) 0px 1px 4px",
            backgroundColor: colorWhite.toString(),
            width: 1280,
            $nest: {
                "@media screen and (max-width: 1280px)": {
                    width: "100%"
                },
                "@media screen and (max-width: 640px)": {
                    width: 320
                },
            }
        }),
        hero: style({
            height: 373,
            position: "relative",
            marginBottom: 24,
            $nest: {
                '> img': {
                    position: "absolute",
                    minWidth: "100%",
                    height: "100%",
                    right: 0,
                    top: 0,
                    $nest: {
                        "@media screen and (max-width: 1000px)": {
                            right: -120
                        },
                        "@media screen and (max-width: 800px)": {
                            right: -160
                        },
                        "@media screen and (max-width: 640px)": {
                            right: 0
                        },
                    }
                },
                "@media screen and (max-width: 640px)": {
                    height: 260
                },
            }
        }),
        logos: style({
            position: "absolute",
            display: "flex",
            flexDirection: "row",
            zIndex: 1,
            top: 16,
            width: "100%",
            paddingRight: 16,
            justifyContent: "flex-end",
            height: "inherit",
            $nest: {
                '& img': {
                    marginLeft: 16,
                    height: "10%",
                    $nest: {
                        "@media screen and (max-width: 640px)": {
                            height: 23
                        }
                    }
                },
            }
        }),
        heroInner: style({
            position: "absolute",
            left: 64,
            top: 139,
            zIndex: 999,
            $nest: {
                "@media screen and (max-width: 1280px)": {
                    width: 500
                },
                "@media screen and (max-width: 800px)": {
                    width: 300
                },
                "@media screen and (max-width: 640px)": {
                    top: 62,
                    left: 17,
                    width: 190
                },
            }
        }),
        heroInnerText: style({
            fontSize: 40,
            lineHeight: 1.2,
            fontFamily: fontHeading,
            fontWeight: 600,
            color: colorWhite.toString(),
            letterSpacing: -1.333,
            marginBottom: 16,
            $nest: {
                "@media screen and (max-width: 800px)": {
                    fontSize: 30
                },
                "@media screen and (max-width: 640px)": {
                    fontSize: 24
                },
            }
        }),
        readMore: style({
            width: "100%",
            textAlign: "center",
            fontSize: 12,
            fontWeight: 400,
            fontFamily: fontBody,
            position: "absolute",
            bottom: 10,
            color: colorWhite.toString()
        }),
        content: style({
            paddingLeft: 64,
            paddingRight: 64,
            color: "#343444",
            lineHeight: 1.5,
            fontSize: 16,
            fontFamily: fontBody,
            $nest: {
                'h4': {
                    fontFamily: fontHeading,
                    fontSize: 24,
                    lineHeight: 1.333,
                    color: "#5900FF"
                },
                'ul': {
                    paddingLeft: '17px',
                    $nest: {
                        '> li': {
                            paddingLeft: "10px"
                        }
                    }
                },
            }
        }, mediaMobileOnly({
            paddingLeft: 16,
            paddingRight: 16,
        })),
        contentMain: style({}, mediaTablet({
            display: "flex",
            justifyContent: "space-between",
            $nest: {
                '> div': {
                    width: "47%"
                }
            }
        })),
        downloadCta: style({
            textAlign: "center",
            $nest: {
                '> a': {
                    marginTop: 19,
                }
            }
        }),
        hottestTracks: style({
            $nest: {
                "@media screen and (min-width: 640px)": {
                    display: "flex",
                    justifyContent: "space-between",
                }
            }
        }),
        artist: style({
            marginBottom: 32,
            maxWidth: 368,
            width: "32%",
            $nest: {
                "@media screen and (max-width: 640px)": {
                   width: "100%"
                },
                "@media screen and (min-width: 640px)": {
                    width: "32%",
                    marginBottom: 32,
                    maxWidth: 368,
                },
                '> a > div': {
                    position: "relative"
                },
                '> a > div > img': {
                    width: 60,
                    position: "absolute",
                    right: 16,
                    top: 16,
                    zIndex: 1
                },
                ':hover .gradient': {
                    opacity: 0.5
                }
            }
        }),
        artistImage: style({
            position: "relative",
            overflow: "hidden",
            marginBottom: 16,
            height: 288,
            $nest: {
                '> img': {
                    width: "100%",
                    position: "absolute"
                },
                "@media screen and (max-width: 768px)": {
                    height: 205
                },
                "@media screen and (max-width: 640px)": {
                    height: 288
                },
            }
        }),
        artistName: style({
            position: "absolute",
            bottom: 16,
            left: 16,
            zIndex: 2,
            color: colorWhite.toString(),
            fontWeight: 400,
            $nest: {
                '> div': {
                    fontSize: 24,
                    fontWeight: 700,
                    lineHeight: 1.333
                }
            }
        }),

    }
}